<div class="users-container">
  <div class="controls-row">
    <button mat-raised-button color="primary" class="add-user-btn" (click)="addUser()">
      <mat-icon>add</mat-icon>
      Add User
    </button>

    <span class="spacer"></span>
  </div>

  @if (loading()) {
    <div class="loading-spinner">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  } @else {
    <div class="section-header">
      <h2>Users</h2>
    </div>

    <div class="table-container">
      @if (dataSource().length === 0) {
        <div class="no-data">
          <p>No users found. Click "Add User" to create one.</p>
        </div>
      } @else {
        <table mat-table [dataSource]="dataSource()" matSort class="users-table">
          <!-- ID Column -->
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
            <td mat-cell *matCellDef="let user">{{user.id}}</td>
          </ng-container>

          <!-- UID Column -->
          <ng-container matColumnDef="uid">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>UID</th>
            <td mat-cell *matCellDef="let user">{{user.uid || '-'}}</td>
          </ng-container>

          <!-- Email Column -->
          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
            <td mat-cell *matCellDef="let user">{{user.email || '-'}}</td>
          </ng-container>

          <!-- Options Column -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let user">
              <button mat-icon-button (click)="impersonateUser(user)" matTooltip="Impersonate User">
                <mat-icon>person</mat-icon>
              </button>
              <button mat-icon-button (click)="deleteUser(user)" matTooltip="Delete User" color="warn">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      }
    </div>
  }
</div>
